import { format, parseISO, isValid } from "date-fns";

export const formatDate = (date) => {
  if (!date) return null;

  const parsed = typeof date === "string" ? parseISO(date) : date;
  return isValid(parsed) ? format(parsed, "yyyy-MM-dd") : null;
};

const titlePrintMetricMapping = {
  Interaction: "interaction"
};

export const mapTitleToRoute = (name) => {
  return titlePrintMetricMapping[name] || name.toLowerCase();
};

export const filterChartDataByDate = (data, from, to) => {
  if (!from || !to) return data;

  const fromDate = formatDate(from);
  const toDate = formatDate(to);

  const filtered = {};

  for (const key in data) {
    if (Array.isArray(data[key])) {
      filtered[key] = data[key].filter((item) => {
        const itemDate = formatDate(item.date);
        return itemDate >= fromDate && itemDate <= toDate;
      });
    } else {
      filtered[key] = data[key];
    }
  }

  return filtered;
};
